

































import {Component, Prop, Vue} from 'vue-property-decorator'
import {SelectOption} from "@/util/selectOption";
import {TransactionData} from "@/util/transactionData";

@Component
export default class LatestTransactions extends Vue {
    @Prop()
    incomeTransactions!: TransactionData[];

    @Prop()
    expenseTransactions!: TransactionData[];

    @Prop()
    incomeDescriptionOptions!: SelectOption[];

    @Prop()
    expenseDescriptionOptions!: SelectOption[];

    private activeTab = 'income';

    private get descriptionOptions(): SelectOption[] {
        return this.activeTab === 'income' ? this.incomeDescriptionOptions :  this.expenseDescriptionOptions;
    }

    private get editTitle(): string {
        return this.activeTab === 'income' ? 'Edit Income' : 'Edit Expense';
    }

    private get activeTransactions(): TransactionData[] {
        if (this.activeTab === 'income') {
            return this.incomeTransactions
        } else {
            return this.expenseTransactions;
        }
    }
}
